import { FC } from 'react'
import { withModalHOC } from 'shared/HOCs/withModalHOC'
import { RenderIf } from 'shared/helpers/renderIf'
import { Text } from 'entities/Text'
import { HelpText } from './styled'

export enum HelpEnum {
  BACKGROUND_IMAGE = 'Background Image',
  LOGO_IMAGE = 'Logo Image',
  APP_IMAGE = 'App Icon'
}

export const Help: FC<HelpProps> = ({ helpType }) => {
  return (
    <>
      <RenderIf condition={helpType === HelpEnum.BACKGROUND_IMAGE}>
        <HelpText>
          <Text>
            <p>
              <b>Size:</b> 1080 × 1920 px (closer to 16:9 fits most devices best).
            </p>
            <p>
              <b>Format:</b> Prefer WebP (best quality/compression). JPEG is also fine.
            </p>
            <p>
              <b>Target file size:</b> 200–500 KB.
            </p>
          </Text>
        </HelpText>
      </RenderIf>
      <RenderIf condition={helpType === HelpEnum.APP_IMAGE}>
        <HelpText>
          <Text>
            <p>
              <b>Size:</b> 512 × 512 px
            </p>
            <p>
              <b>Format:</b> PNG recommended (sharp edges).
            </p>
            <p>
              <b>Background:</b> Can be transparent. iOS/Android will automatically fill it.
            </p>
            <p>
              <b>Target file size:</b> ≤ 300 KB
            </p>
          </Text>
        </HelpText>
      </RenderIf>
      <RenderIf condition={helpType === HelpEnum.LOGO_IMAGE}>
        <HelpText>
          <Text>
            <p>
              <b>Shape:</b> Square is recommended, but not required. Proportions are kept
              automatically.
            </p>
            <p>
              <b>Format priority:</b> SVG → PNG → JPEG
            </p>
            <p>
              <b>Resolution:</b> At least 750 × 750 px
            </p>
            <p>
              <b>Target file size:</b> ≤ 500 KB
            </p>
          </Text>
        </HelpText>
      </RenderIf>
    </>
  )
}

type HelpProps = {
  helpType: HelpEnum
}

export const HelpModal = withModalHOC(Help)
